import React from 'react';
import { Link } from 'react-router-dom';
import { Award, ShieldCheck, ArrowRight } from 'lucide-react';
export function AboutSection() {
  return <section id="about" className="py-12 lg:py-16 bg-white" data-id="element-24">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-25">
        <div className="grid lg:grid-cols-2 gap-10 items-center" data-id="element-26">
          <div className="relative" data-id="element-27">
            <div className="aspect-[4/5] max-w-sm mx-auto lg:mx-0 rounded-2xl overflow-hidden relative shadow-soft-lg" data-id="element-28">
              <img src="https://cdn.magicpatterns.com/uploads/2aYmNjfJeM1CXoD7BhqyB6/Homepage_Esther.png" alt="Esther Mensah - Registered Social Worker & Psychotherapist" className="w-full h-full object-cover object-top" data-id="element-29" />
            </div>
            <div className="absolute -bottom-4 -right-4 w-32 h-32 bg-olive/10 rounded-full -z-10 hidden lg:block" data-id="element-30" />
          </div>

          <div data-id="element-31">
            <div data-id="element-32">
              <span className="inline-block bg-olive text-white font-bold uppercase tracking-widest text-xs px-4 py-1.5 rounded-full mb-4" data-id="element-33">
                ABOUT ME
              </span>
              <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-charcoal mb-4 leading-tight" data-id="element-34">
                A Safe Space for Your
                <br data-id="element-35" />
                <span className="italic text-gold" data-id="element-36">Healing Journey</span>
              </h2>
            </div>

            <div data-id="element-37">
              <div className="space-y-4 text-charcoal/80 mb-8 font-medium text-base leading-relaxed" data-id="element-38">
                <p data-id="element-39">
                  I'm Esther Mensah, a licensed professional counsellor
                  dedicated to providing compassionate, culturally sensitive
                  therapy. I believe that everyone deserves access to quality
                  mental health care in a safe, non-judgmental environment.
                </p>
                <p data-id="element-40">
                  My approach integrates evidence-based practices with a deep
                  understanding of cultural and personal identity. Whether
                  you're navigating anxiety, depression, trauma, or relationship
                  challenges, I'm here to support your journey toward healing
                  and growth.
                </p>
              </div>
            </div>

            <div data-id="element-41">
              <div className="grid grid-cols-2 gap-3 mb-8" data-id="element-42">
                <div className="flex items-center gap-3 bg-olive/5 rounded-xl p-3" data-id="element-43">
                  <div className="w-9 h-9 rounded-lg bg-olive/10 flex items-center justify-center text-olive flex-shrink-0" data-id="element-44">
                    <Award size={18} data-id="element-45" />
                  </div>
                  <span className="text-sm font-bold text-charcoal leading-tight" data-id="element-46">
                    MSc Clinical
                    <br data-id="element-47" />
                    Psychology
                  </span>
                </div>
                <div className="flex items-center gap-3 bg-olive/5 rounded-xl p-3" data-id="element-48">
                  <div className="w-9 h-9 rounded-lg bg-olive/10 flex items-center justify-center text-olive flex-shrink-0" data-id="element-49">
                    <ShieldCheck size={18} data-id="element-50" />
                  </div>
                  <span className="text-sm font-bold text-charcoal leading-tight" data-id="element-51">
                    Licensed Professional
                    <br data-id="element-52" />
                    Counsellor
                  </span>
                </div>
              </div>

              <Link to="/about" className="inline-flex items-center justify-center bg-olive hover:bg-olive/90 text-white px-6 py-3 rounded-full font-bold text-base transition-all shadow-soft hover:shadow-soft-lg min-h-[48px] tracking-wide" data-id="element-53">
                Learn More About Me
                <ArrowRight size={16} className="ml-2" data-id="element-54" />
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>;
}